"use client";

// src/components/atoms/Heading/Heading.styles.ts
import { tv } from "tailwind-variants";
var heading = tv(
  {
    base: "text-display-900 font-bold font-ton",
    variants: {
      type: {
        "h1": "text-36 lg:text-48 leading-44 lg:leading-56",
        "h2": "text-32 lg:text-40 leading-38 lg:leading-48",
        "h3": "text-28 lg:text-32 leading-36 lg:leading-40",
        "h4": "text-24 lg:text-28 leading-32 lg:leading-36",
        "h5": "text-20 lg:text-24 leading-28 lg:leading-32",
        "h6": "text-18 lg:text-20 leading-26 lg:leading-28"
      }
    },
    defaultVariants: {
      type: "h1"
    }
  },
  {
    twMerge: false
  }
);

export {
  heading
};
